import { ca } from '@cian/analytics';

import { IPage } from '../../types/redux/page';
import { getSiteType } from '../../utils/getSiteType';

export interface ITrackClickNextData {
  page: IPage;
  queryString: string;
  address?: string;
  area?: number;
  roomsCount?: number;
}

export function trackClickNext(params: ITrackClickNextData) {
  const { page, queryString, address, area, roomsCount } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click',
    label: 'Calculate',
    page: {
      pageType: page.pageType,
      siteType: getSiteType(page.deviceType),
      queryString,
      extra: {
        address: address || undefined,
        area: area || undefined,
        roomsCount: roomsCount || undefined,
      },
    },
  });
}
